<div class="footer">
  <div [ngClass]="{ 'blue-border': !showLogout() }" class="footer-container">
    @if (!showLogout()) {
      <resto-language-selector
        [prefix]="true"
        [model]="currentLang()"
      ></resto-language-selector>
    }

    <ul>
      <li>
        <a
          class="mat-caption"
          target="_blank"
          [href]="imprintUrl[currentLang()]"
          >{{ 'shared.footer.imprint' | transloco }}</a
        >
      </li>
      <li>
        <a
          class="mat-caption"
          target="_blank"
          [href]="privacyUrl[currentLang()]"
          >{{ 'shared.footer.privacy' | transloco }}</a
        >
      </li>
      <li>
        <a
          class="mat-caption"
          target="_blank"
          [href]="termsUrl[currentLang()]"
          >{{ 'shared.footer.terms' | transloco }}</a
        >
      </li>
    </ul>

    @if (showLogout()) {
      <div class="footer-text">
        <button mat-button (click)="goBackToOrderTaking()">
          <mat-icon>settings</mat-icon>
          {{ 'shared.footer.back-to-order-taking' | transloco }}
        </button>

        <button mat-button (click)="logOut()">
          <mat-icon>logout</mat-icon>
          {{ 'shared.footer.logout' | transloco }}
        </button>
      </div>
    }
  </div>
</div>
